import { __assign, __extends, __read, __rest } from "tslib";
import React, { useEffect, useState } from "react";
import EventEmitter from "eventemitter3";
import { Modal } from "./Modal";
import { callBoth } from "../_util/call-both";
var ModalEmitter = /** @class */ (function (_super) {
    __extends(ModalEmitter, _super);
    function ModalEmitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModalEmitter;
}(EventEmitter));
export var modalEmitter = new ModalEmitter();
export function ModalManager(props) {
    var _a = __read(useState(props), 2), options = _a[0], setOptions = _a[1];
    useEffect(function () {
        var onShow = function (_a) {
            var options = __rest(_a, []);
            setOptions(__assign(__assign({}, options), { visible: true }));
        };
        var onHide = function () {
            setOptions(function (options) { return (__assign(__assign({}, options), { visible: false })); });
        };
        modalEmitter.on("show", onShow);
        modalEmitter.on("hide", onHide);
        return function () {
            modalEmitter.removeListener("show", onShow);
            modalEmitter.removeListener("hide", onHide);
        };
    }, []);
    return (React.createElement(Modal, __assign({}, options, { destroyOnClose: true, onClose: callBoth(options.onClose, function () { return modalEmitter.emit("hide"); }) })));
}
//# sourceMappingURL=ModalManager.js.map